import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Selection,
} from '@nextui-org/react'
import useChartStore from '../../store/chart/useChartStore'
import { useAuthStore } from '../../store/auth/useAuthStore'
import { Properties, PropertiesWithoutWater } from './config'
import { PropertyName } from '../../types/apiResponse/chartTypes'

export const SelectProperties = () => {
  const { properties, setProperties } = useChartStore()
  const { userId } = useAuthStore()

  const onSelectionChange = (keys: Selection) => {
    if (keys === 'all') {
      // Handle "all" selection - set all available properties
      const allProperties = Object.keys(
        userId === 'fishcafe@tidepool.kr' ? PropertiesWithoutWater : Properties,
      ) as PropertyName[]
      setProperties(allProperties)
    } else {
      // Convert Set to PropertyName array
      const selectedProperties = Array.from(keys) as PropertyName[]
      setProperties(selectedProperties)
    }
  }

  return (
    <Dropdown className="flex ml-auto">
      <DropdownTrigger>
        <Button
          variant="bordered"
          className="font-bold capitalize border border-opacity-0 text-tdplprussian"
        >
          Properties ▾
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Select Properties"
        selectionMode="multiple"
        closeOnSelect={false}
        selectedKeys={properties}
        onSelectionChange={onSelectionChange}
      >
        {Object.entries(
          userId === 'fishcafe@tidepool.kr' ? PropertiesWithoutWater : Properties,
        ).map((item) => {
          return (
            <DropdownItem className="text-tdplprussian" key={item[0]}>
              {item[1]}
            </DropdownItem>
          )
        })}
      </DropdownMenu>
    </Dropdown>
  )
}
